// extracted by mini-css-extract-plugin
module.exports = {"block":"Partners_block__30xD7","title":"Partners_title__1iMVh","list":"Partners_list__REYGa","img":"Partners_img__1oBGx","stopcoronovirus":"Partners_stopcoronovirus__1HC9h"};